<template>
  <div class="error-centered">
    {{ translatedError }}
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'ErrorPage',
  props: {
    errorKey: { type: String, default: 'generic' },
  },
  setup(props) {
    const { t } = useI18n();

    const translatedError = computed(() => {
      return t(`error_page.${props.errorKey}`);
    });

    return {
      translatedError,
    };
  }  
})
</script>

<style>
.error-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: bold;
  font-size: larger;
}
</style>
